import { SpecialInstructions } from './lifestyle.model';

export class UnderWritingData {
    lifeStyleRiskWarning: string;
    annuitantMedicalConditions: AnnuitantMedicalConditions[];
    dependentMedicalConditions: AnnuitantMedicalConditions[];
    riskAndStaticQuestion: RiskWarningModel = null;
}

export class AnnuitantMedicalConditions {
    questionSetName: string = "Lifestyle";
    index: number;
    questions: QuestionsToAPI[];
    status: string;
}

export class QuestionsToAPI {
    id: string;
    sectionName: string;
    responseValue: string = "";
    origoSection: string;
    origoElement: string;
    origoAttribute: string;
    index: string = "0";
    recurrenceInd: boolean = false;
    specialInstructions: SpecialInstructions[];
    questionModels: QuestionsToAPI[] = null;
    mandatoryResponse: string;
}

export class RiskWarningModel {
    questionCode: string;
    questionType: string;
    answer: string;
}
